import React from 'react';
import ARadio from 'antd-mobile/lib/radio';



export default class Radio extends ARadio {}